import { render, staticRenderFns } from "./InfoWidget.vue?vue&type=template&id=5b022cde&scoped=true"
import script from "./InfoWidget.vue?vue&type=script&lang=js"
export * from "./InfoWidget.vue?vue&type=script&lang=js"
import style0 from "./InfoWidget.vue?vue&type=style&index=0&id=5b022cde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b022cde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
